import { DoubleArrowOutlined } from "@mui/icons-material";
import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import { primary } from "../../constants/theme";
import ConvertibleCard from "../../SDK/Cards/convertibleCard";
import { myScroll } from "../../utils/myScroll";

const CustomBenefitSection = styled(Box)(({ theme }) => ({
  ".headerInfo": {
    fontSize: "28px",
    fontWeight: "600",
  },

  ".headerBorder": {
    width: "100px",
    height: "8px",
    borderRadius: "100px",
    background: primary.main,
  },

  ".subHeaderInfo": {
    fontSize: "24px",
    fontWeight: "600",
  },

  ".headerDescription": {
    fontSize: "16px",
    color: primary.greyText,
  },

  ".cta": {
    fontSize: "18px",
    fontWeight: "600",
    color: primary.main,
  },
  [theme.breakpoints.down("md")]: {
    ".headerInfo": {
      fontSize: "22px",
    },

    ".subHeaderInfo": {
      fontSize: "16px",
      fontWeight: "600",
    },
    ".headerDescription": {
      fontSize: "12px",
      color: primary.greyText,
    },
    ".headerBorder": {
      width: "60px",
      height: "6px",
      borderRadius: "100px",
      background: primary.main,
    },
    ".cta": {
      fontSize: "12px",
      fontWeight: "600",
      color: primary.main,
    },
  },
}));

const benefits = [
  {
    id: 0,
    title: "Many brands, One store",
    description: "Find the best brands of electric gadis here",
    path: "",
    image: `${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/benefit1.webp`,
    cta: "Visit Now",
  },
  {
    id: 4,
    title: "Get unbiased expert advise",
    description: "We help you find the best gadi for your business",
    path: "",
    image: `${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/benefit5.webp`,
    cta: "Visit Now",
  },
  {
    id: 1,
    title: "Take a Test Drive",
    description: "Visit Turno store to take a test drive",
    path: "",
    image: `${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/benefit2.webp`,
    cta: "Book A Test Drive",
  },
  {
    id: 2,
    title: "Quick Financing",
    description: "Quick and easy financing at the store",
    path: "",
    image: `${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/benefit3.webp`,
    cta: "Visit Now",
  },
  {
    id: 3,
    title: "3 Day Gadi Delivery",
    description: "Take your electric gaadi home in just 3 days",
    path: "",
    image: `${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/benefit4.webp`,
    cta: "Visit Now",
  },
];

const BenefitSection = () => {
  return (
    <CustomBenefitSection>
      <Stack
        sx={{ margin: { xs: "32px 16px 16px 16px", sm: "16px 0px 0px 32px" } }}
      >
        <Typography flexDirection={"column"} className="headerInfo">
          Benefits of booking a gadi at the store 
        </Typography>
        <Box className="headerBorder" />{" "}
      </Stack>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          margin: { xs: "0.5em", md: "6em" },
        }}
      >
        <Grid container spacing={2}>
          {benefits.map((res, index) => {
            return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ConvertibleCard position={index % 2} imageSrc={res?.image}>
                  <Box
                    flexDirection={"column"}
                    display="flex"
                    width="100%"
                    height="100%"
                    justifyContent={"space-around"}
                  >
                    <Typography
                      component="div"
                      className="subHeaderInfo"
                      //style={{ fontSize: "15px", fontWeight: "600" }}
                    >
                      {res.title}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      component="div"
                      className="headerDescription"
                    >
                      {res.description}
                    </Typography>

                    <Box
                      flexDirection={"row"}
                      display="flex"
                      width="100%"
                      justifyContent={"space-between"}
                      sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                      onClick={() => {
                        myScroll(
                          0,
                          document.getElementById("book-ticket").offsetTop -
                            100,
                          "smooth"
                        );
                      }}
                    >
                      <Typography
                        justifyContent={"flex-start"}
                        className="cta"
                        // style={{
                        //   fontSize: "12px",
                        //   fontWeight: "600",
                        //   color: primary.main,
                        // }}
                      >
                        {res.cta}
                      </Typography>
                      <Typography justifyContent={"flex-end"} className="cta">
                        <DoubleArrowOutlined />
                      </Typography>
                    </Box>
                  </Box>
                </ConvertibleCard>
              </Grid>
            );
          })}
          {/* <Grid
            item
            sm={12}
            md={3}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ConvertibleCard
              position={1}
              imageSrc={
                "https://assets.turnoclub.com/developer/offer-turno-images/S3/Finance/telangana.avif"
              }
            >
              <Box
                flexDirection={"column"}
                display="flex"
                width="100%"
                height="100%"
                justifyContent={"space-around"}
              >
                <Typography component="div" variant="h5">
                  Live From Space
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                  sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                >
                  Mac Miller
                </Typography>

                <Box
                  flexDirection={"row"}
                  display="flex"
                  width="100%"
                  justifyContent={"space-between"}
                  sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                >
                  <Typography justifyContent={"flex-start"}>
                    Visit Now
                  </Typography>
                  <Typography justifyContent={"flex-end"}>
                    <DoubleArrowOutlined />
                  </Typography>
                </Box>
              </Box>
            </ConvertibleCard>
          </Grid>
          <Grid
            item
            sm={12}
            md={3}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ConvertibleCard
              imageSrc={
                "https://assets.turnoclub.com/developer/offer-turno-images/S3/Finance/telangana.avif"
              }
            >
              <Box
                flexDirection={"column"}
                display="flex"
                width="100%"
                height="100%"
                justifyContent={"space-around"}
              >
                <Typography component="div" variant="h5">
                  Live From Space
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                  sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                >
                  Mac Miller
                </Typography>

                <Box
                  flexDirection={"row"}
                  display="flex"
                  width="100%"
                  justifyContent={"space-between"}
                  sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                >
                  <Typography justifyContent={"flex-start"}>
                    Visit Now
                  </Typography>
                  <Typography justifyContent={"flex-end"}>
                    <DoubleArrowOutlined />
                  </Typography>
                </Box>
              </Box>
            </ConvertibleCard>
          </Grid>

          <Grid
            item
            sm={12}
            md={3}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ConvertibleCard
              imageSrc={
                "https://assets.turnoclub.com/developer/offer-turno-images/S3/Finance/telangana.avif"
              }
            >
              <Box
                flexDirection={"column"}
                display="flex"
                width="100%"
                height="100%"
                justifyContent={"space-around"}
              >
                <Typography component="div" variant="h5">
                  Live From Space
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                  sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                >
                  Mac Miller
                </Typography>

                <Box
                  flexDirection={"row"}
                  display="flex"
                  width="100%"
                  justifyContent={"space-between"}
                  sx={{ paddingTop: { xs: "12px", md: "24px" } }}
                >
                  <Typography justifyContent={"flex-start"}>
                    Visit Now
                  </Typography>
                  <Typography justifyContent={"flex-end"}>
                    <DoubleArrowOutlined />
                  </Typography>
                </Box>
              </Box>
            </ConvertibleCard>
          </Grid> */}
        </Grid>
      </Box>
    </CustomBenefitSection>
  );
};

export default BenefitSection;
